import { each } from "lodash";
import { x, x0 } from "../../../_helpers";

export default class HeaderMegaMenu {
  constructor() {
    this.el = x0(".fo-header.-megamenu");
    if (!this.el) return;
    this.menuTriggers = x("[js-megamenu-trigger]", this.el);
    this.init();
  }

  onItemClick = (index) => {
    each(this.menuTriggers, (el) => el.classList.remove("-is-active"));
    this.menuTriggers[index].classList.add("-is-active");
    this.el.classList.remove("-state-0", "-state-1", "-state-2");
    this.el.classList.add(`-state-${index}`);
  };

  attachEvents = () => {
    each(this.menuTriggers, (el, j) => {
      el.addEventListener("click", this.onItemClick.bind(this, j));
    });
  };

  init() {
    this.attachEvents();
  }
}
